import { Close, PlayIcon, Hamburger, LeftArrow, LikeButton, ShareIcon, ChevronUp, ChevronDown, Search, PlayButton, UnFavorite, Episode, Clear, GoBack, More, Favorite, PremiumIcon, ProfileIcon, AngleLeftIcon, AngleRightIcon, SearchMini, Success, Error, Mail, Phone, PremiumMemberIcon, Video, MastHeadPlayButton, HoverPlayIcon, HeaderPremium, AppStore, LogIn, CloseSearch, SearchPlayIcon, GoToTop, ClearSearchValue, FullEpisode, LinkTvApp, LiveTvTag, DPlusIcon, YoutubeIcon, FB, Plus18Tag, GeoMask, DplusPlaceHolder, PlayStore, AllCaughtUp, AllAccessSuccess, AllAccess, NoContentDFavourites, NoContentFavourites, NoContentShorts, BottomMenuHomeActive, BottomMenuHomeInActive, BottomMenuExploreActive, BottomMenuExploreInActive, BottomMenuShortsActive, BottomMenuShortsInActive, BottomMenuMindBlownActive, BottomMenuMindBlownInActive, BottomMenuPremiumActive, BottomMenuPremiumInActive, BottomMenuKidsInActive, PinMisMacth, CopyLink, Twitter, FaceBookShareIcon, WhatsApp, ConnectionSuccess, BottomMenuKidsActive, DplusKidsPlaceHolder, KidsPlayIcon, CircularSpinner, KidsPlayIconTabletMenu, TabletMenuHome, TabletMenuExplore, TabletMenuShorts, TabletMenuMindBlown, TabletMenuPremium, Cancel, OpenInvertedCommas, ClosingInvertedCommas, RoundedPlayIcon, Yes, No, LeftArrowC, RightArrowC, RedeemVoucher, } from "./icons";
export var Icons;
(function (Icons) {
    Icons["Cancel"] = "Cancel";
    Icons["Close"] = "Close";
    Icons["PlayIcon"] = "PlayIcon";
    Icons["Hamburger"] = "Hamburger";
    Icons["LeftArrow"] = "LeftArrow";
    Icons["LikeButton"] = "LikeButton";
    Icons["ShareIcon"] = "ShareIcon";
    Icons["ChevronUp"] = "ChevronUp";
    Icons["ChevronDown"] = "ChevronDown";
    Icons["PlayButton"] = "PlayButton";
    Icons["Search"] = "Search";
    Icons["UnFavorite"] = "UnFavorite";
    Icons["Episode"] = "Episode";
    Icons["Clear"] = "Clear";
    Icons["GoBack"] = "GoBack";
    Icons["More"] = "More";
    Icons["Favorite"] = "Favorite";
    Icons["Premium"] = "Premium";
    Icons["PremiumIcon"] = "PremiumIcon";
    Icons["ProfileIcon"] = "ProfileIcon";
    Icons["AngleLeftIcon"] = "AngleLeftIcon";
    Icons["AngleRightIcon"] = "AngleRightIcon";
    Icons["SearchMini"] = "SearchMini";
    Icons["Success"] = "Success";
    Icons["Error"] = "Error";
    Icons["Mail"] = "Mail";
    Icons["Phone"] = "Phone";
    Icons["PremiumMemberIcon"] = "PremiummemberIcon";
    Icons["Video"] = "Video";
    Icons["MastHeadPlayButton"] = "MastHeadPlayButton";
    Icons["HoverPlayIcon"] = "HoverPlayIcon";
    Icons["HeaderPremium"] = "HeaderPremium";
    Icons["AppStore"] = "AppStore";
    Icons["LogIn"] = "LogIn";
    Icons["CloseSearch"] = "CloseSearch";
    Icons["SearchPlayIcon"] = "SearchPlayIcon";
    Icons["GoToTop"] = "GoToTop";
    Icons["ClearSearchValue"] = "ClearSearchValue";
    Icons["FullEpisode"] = "FullEpisode";
    Icons["LinkTvApp"] = "LinkTvApp";
    Icons["LiveTvTag"] = "LiveTvTag";
    Icons["FooterAppStore"] = "FooterAppStore";
    Icons["DPlusIcon"] = "DPlusIcon";
    Icons["YoutubeIcon"] = "YoutubeIcon";
    Icons["FB"] = "FB";
    Icons["Plus18Tag"] = "Plus18Tag";
    Icons["GeoMask"] = "GeoMask";
    Icons["DplusPlaceHolder"] = "DplusPlaceHolder";
    Icons["PlayStore"] = "PlayStore";
    Icons["AllCaughtUp"] = "AllCaughtUp";
    Icons["AllAccessSuccess"] = "AllAccessSuccess";
    Icons["AllAccess"] = "AllAccess";
    Icons["NoContentDFavourites"] = "NoContentDFavourites";
    Icons["NoContentFavourites"] = "NoContentFavourites";
    Icons["NoContentShorts"] = "NoContentShorts";
    Icons["BottomMenuHomeActive"] = "BottomMenuHomeActive";
    Icons["BottomMenuHomeInActive"] = "BottomMenuHomeInActive";
    Icons["BottomMenuExploreActive"] = "BottomMenuExploreActive";
    Icons["BottomMenuExploreInActive"] = "BottomMenuExploreInActive";
    Icons["BottomMenuShortsActive"] = "BottomMenuShortsActive";
    Icons["BottomMenuShortsInActive"] = "BottomMenuShortsInActive";
    Icons["BottomMenuMindBlownActive"] = "BottomMenuMindBlownActive";
    Icons["BottomMenuMindBlownInActive"] = "BottomMenuMindBlownInActive";
    Icons["BottomMenuPremiumActive"] = "BottomMenuPremiumActive";
    Icons["BottomMenuPremiumInActive"] = "BottomMenuPremiumInActive";
    Icons["BottomMenuKidsInActive"] = "BottomMenuKidsInActive";
    Icons["PinMisMacth"] = "PinMisMacth";
    Icons["CopyLink"] = "CopyLink";
    Icons["Twitter"] = "Twitter";
    Icons["FaceBookShareIcon"] = "FaceBookShareIcon";
    Icons["WhatsApp"] = "WhatsApp";
    Icons["ConnectionSuccess"] = "ConnectionSuccess";
    Icons["BottomMenuKidsActive"] = "BottomMenuKidsActive";
    Icons["DplusKidsPlaceHolder"] = "DplusKidsPlaceHolder";
    Icons["KidsPlayIcon"] = "KidsPlayIcon";
    Icons["Loading"] = "Loading";
    Icons["CircularSpinner"] = "CircularSpinner";
    Icons["KidsPlayIconTabletMenu"] = "KidsPlayIconTabletMenu";
    Icons["TabletMenuHome"] = "TabletMenuHome";
    Icons["TabletMenuExplore"] = "TabletMenuExplore";
    Icons["TabletMenuMindBlown"] = "TabletMenuMindBlown";
    Icons["TabletMenuShorts"] = "TabletMenuShorts";
    Icons["TabletMenuPremium"] = "TabletMenuPremium";
    Icons["OpenInvertedCommas"] = "OpenInvertedCommas";
    Icons["ClosingInvertedCommas"] = "ClosingInvertedCommas";
    Icons["RightArrowWithBackground"] = "RightArrowWithBackground";
    Icons["LeftArrowWithBackground"] = "LeftArrowWithBackground";
    Icons["RoundedPlayIcon"] = "RoundedPlayIcon";
    Icons["YES"] = "yes";
    Icons["NO"] = "no";
    Icons["LeftArrowC"] = "LeftArrowC";
    Icons["RightArrowC"] = "RightArrowC";
    Icons["RedeemVoucher"] = "RedeemVoucher";
})(Icons || (Icons = {}));
export const Icon = ({ type, className, color, subColor, width, height, }) => {
    switch (type) {
        case Icons.YoutubeIcon: {
            return (React.createElement(YoutubeIcon, { className: className, color: color, subColor: subColor }));
        }
        case Icons.DPlusIcon: {
            return React.createElement(DPlusIcon, { className: className, color: color });
        }
        case Icons.Close: {
            return React.createElement(Close, { className: className, color: color });
        }
        case Icons.Cancel: {
            return React.createElement(Cancel, { className: className });
        }
        case Icons.PlayIcon: {
            return React.createElement(PlayIcon, { className: className, color: color });
        }
        case Icons.Hamburger: {
            return React.createElement(Hamburger, { className: className, color: color });
        }
        case Icons.LeftArrow: {
            return React.createElement(LeftArrow, { className: className, color: color });
        }
        case Icons.ChevronUp: {
            return React.createElement(ChevronUp, { className: className, color: color });
        }
        case Icons.ChevronDown: {
            return React.createElement(ChevronDown, { className: className, color: color });
        }
        case Icons.PlayButton: {
            return React.createElement(PlayButton, { className: className, color: color });
        }
        case Icons.LikeButton: {
            return React.createElement(LikeButton, { className: className, color: color });
        }
        case Icons.ShareIcon: {
            return React.createElement(ShareIcon, { className: className, color: color });
        }
        case Icons.Search: {
            return React.createElement(Search, { className: className, color: color });
        }
        case Icons.Clear: {
            return React.createElement(Clear, { className: className, color: color });
        }
        case Icons.GoBack: {
            return React.createElement(GoBack, { className: className, color: color });
        }
        case Icons.UnFavorite: {
            return React.createElement(UnFavorite, { className: className, color: color });
        }
        case Icons.Favorite: {
            return React.createElement(Favorite, { className: className });
        }
        case Icons.Episode: {
            return React.createElement(Episode, { className: className });
        }
        case Icons.More: {
            return React.createElement(More, { className: className, color: color });
        }
        case Icons.PremiumIcon: {
            return React.createElement(PremiumIcon, { className: className, color: color });
        }
        case Icons.ProfileIcon: {
            return React.createElement(ProfileIcon, { className: className });
        }
        case Icons.AngleLeftIcon: {
            return React.createElement(AngleLeftIcon, { className: className, color: color });
        }
        case Icons.AngleRightIcon: {
            return React.createElement(AngleRightIcon, { className: className, color: color });
        }
        case Icons.Mail: {
            return React.createElement(Mail, { className: className, color: color });
        }
        case Icons.SearchMini: {
            return React.createElement(SearchMini, { className: className, color: color });
        }
        case Icons.Success: {
            return React.createElement(Success, null);
        }
        case Icons.Error: {
            return React.createElement(Error, null);
        }
        case Icons.Phone: {
            return React.createElement(Phone, { className: className });
        }
        case Icons.PremiumMemberIcon: {
            return React.createElement(PremiumMemberIcon, { className: className });
        }
        case Icons.Video: {
            return React.createElement(Video, { className: className, color: color });
        }
        case Icons.HoverPlayIcon: {
            return React.createElement(HoverPlayIcon, { className: className, color: color });
        }
        case Icons.MastHeadPlayButton: {
            return React.createElement(MastHeadPlayButton, { className: className, color: color });
        }
        case Icons.HeaderPremium: {
            return React.createElement(HeaderPremium, { className: className, color: color });
        }
        case Icons.LogIn: {
            return React.createElement(LogIn, { className: className, color: color });
        }
        case Icons.CloseSearch: {
            return React.createElement(CloseSearch, { className: className });
        }
        case Icons.SearchPlayIcon: {
            return React.createElement(SearchPlayIcon, { className: className, color: color });
        }
        case Icons.FullEpisode: {
            return React.createElement(FullEpisode, { className: className, color: color });
        }
        case Icons.GoToTop: {
            return React.createElement(GoToTop, { className: className, color: color });
        }
        case Icons.ClearSearchValue: {
            return React.createElement(ClearSearchValue, { className: className, color: color });
        }
        case Icons.LinkTvApp: {
            return React.createElement(LinkTvApp, { className: className });
        }
        case Icons.LiveTvTag: {
            return React.createElement(LiveTvTag, { className: className });
        }
        case Icons.FB: {
            return React.createElement(FB, { className: className, color: color, subColor: subColor });
        }
        case Icons.Plus18Tag: {
            return React.createElement(Plus18Tag, { className: className });
        }
        case Icons.GeoMask: {
            return React.createElement(GeoMask, { className: className });
        }
        case Icons.DplusPlaceHolder: {
            return React.createElement(DplusPlaceHolder, { className: className });
        }
        case Icons.PlayStore: {
            return React.createElement(PlayStore, { className: className, width: width, height: height });
        }
        case Icons.AppStore: {
            return React.createElement(AppStore, { className: className, width: width, height: height });
        }
        case Icons.AllCaughtUp: {
            return React.createElement(AllCaughtUp, { className: className });
        }
        case Icons.AllAccessSuccess: {
            return React.createElement(AllAccessSuccess, { className: className });
        }
        case Icons.AllAccess: {
            return React.createElement(AllAccess, { className: className });
        }
        case Icons.NoContentDFavourites: {
            return React.createElement(NoContentDFavourites, { className: className });
        }
        case Icons.NoContentFavourites: {
            return React.createElement(NoContentFavourites, { className: className });
        }
        case Icons.NoContentShorts: {
            return React.createElement(NoContentShorts, { className: className });
        }
        case Icons.BottomMenuHomeActive: {
            return React.createElement(BottomMenuHomeActive, { className: className });
        }
        case Icons.BottomMenuHomeInActive: {
            return React.createElement(BottomMenuHomeInActive, { className: className });
        }
        case Icons.BottomMenuExploreActive: {
            return React.createElement(BottomMenuExploreActive, { className: className });
        }
        case Icons.BottomMenuExploreInActive: {
            return React.createElement(BottomMenuExploreInActive, { className: className });
        }
        case Icons.BottomMenuShortsActive: {
            return React.createElement(BottomMenuShortsActive, { className: className });
        }
        case Icons.BottomMenuShortsInActive: {
            return React.createElement(BottomMenuShortsInActive, { className: className });
        }
        case Icons.BottomMenuMindBlownActive: {
            return React.createElement(BottomMenuMindBlownActive, { className: className });
        }
        case Icons.BottomMenuMindBlownInActive: {
            return React.createElement(BottomMenuMindBlownInActive, { className: className });
        }
        case Icons.BottomMenuPremiumActive: {
            return React.createElement(BottomMenuPremiumActive, { className: className });
        }
        case Icons.BottomMenuPremiumInActive: {
            return React.createElement(BottomMenuPremiumInActive, { className: className });
        }
        case Icons.BottomMenuKidsActive: {
            return React.createElement(BottomMenuKidsActive, { className: className });
        }
        case Icons.BottomMenuKidsInActive: {
            return React.createElement(BottomMenuKidsInActive, { className: className });
        }
        case Icons.PinMisMacth: {
            return React.createElement(PinMisMacth, { className: className });
        }
        case Icons.CopyLink: {
            return React.createElement(CopyLink, { className: className });
        }
        case Icons.Twitter: {
            return React.createElement(Twitter, { className: className });
        }
        case Icons.FaceBookShareIcon: {
            return React.createElement(FaceBookShareIcon, { className: className });
        }
        case Icons.WhatsApp: {
            return React.createElement(WhatsApp, { className: className });
        }
        case Icons.ConnectionSuccess: {
            return React.createElement(ConnectionSuccess, { className: className });
        }
        case Icons.DplusKidsPlaceHolder: {
            return React.createElement(DplusKidsPlaceHolder, { className: className });
        }
        case Icons.KidsPlayIcon: {
            return React.createElement(KidsPlayIcon, { className: className, color: color });
        }
        case Icons.KidsPlayIconTabletMenu: {
            return React.createElement(KidsPlayIconTabletMenu, { className: className, color: color });
        }
        case Icons.TabletMenuHome: {
            return React.createElement(TabletMenuHome, { className: className });
        }
        case Icons.TabletMenuExplore: {
            return React.createElement(TabletMenuExplore, { className: className });
        }
        case Icons.TabletMenuMindBlown: {
            return React.createElement(TabletMenuMindBlown, { className: className });
        }
        case Icons.TabletMenuShorts: {
            return React.createElement(TabletMenuShorts, { className: className });
        }
        case Icons.TabletMenuPremium: {
            return React.createElement(TabletMenuPremium, { className: className });
        }
        case Icons.CircularSpinner: {
            return React.createElement(CircularSpinner, { className: className });
        }
        case Icons.OpenInvertedCommas: {
            return React.createElement(OpenInvertedCommas, { className: className });
        }
        case Icons.ClosingInvertedCommas: {
            return React.createElement(ClosingInvertedCommas, { className: className });
        }
        case Icons.RoundedPlayIcon: {
            return React.createElement(RoundedPlayIcon, { className: className });
        }
        case Icons.YES: {
            return React.createElement(Yes, { className: className });
        }
        case Icons.NO: {
            return React.createElement(No, { className: className });
        }
        case Icons.LeftArrowC: {
            return React.createElement(LeftArrowC, { className: className });
        }
        case Icons.RightArrowC: {
            return React.createElement(RightArrowC, { className: className });
        }
        case Icons.RedeemVoucher: {
            return React.createElement(RedeemVoucher, { className: className });
        }
        default:
            return React.createElement(React.Fragment, null);
    }
};

